import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["buttonType", "children", "chipElevation", "disabled", "icon", "iconPosition", "iconSize", "inverse", "size"];
import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { ChipLabel } from '../AssistChip/ChipLabel';
import { StyledFilterChip } from './FilterChip.styles';

/**
 * Filter chips are toggles used mainly for filtering and sorting content (ex: search filters).
 *
 * @extends ToggleButton
 * @related ['AssistChip', 'Checkbox', 'InputChip', 'Switch']
 * @since 8.97.0
 */
export var FilterChip = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var buttonType = props.buttonType,
    children = props.children,
    chipElevation = props.chipElevation,
    disabled = props.disabled,
    icon = props.icon,
    iconPosition = props.iconPosition,
    iconSize = props.iconSize,
    inverse = props.inverse,
    size = props.size,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(StyledFilterChip, _extends({
    buttonType: "tertiary",
    chipElevation: chipElevation,
    disabled: disabled,
    icon: icon,
    iconPosition: "start",
    iconSize: "xs",
    ref: forwardedRef,
    type: "button"
  }, rest), /*#__PURE__*/React.createElement(ChipLabel, null, children));
});
FilterChip.displayName = 'FilterChip';
FilterChip.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The assist chip’s text label. To add decorators, use the `icon` and `avatar` props.
   */
  children: PropTypes.node.isRequired,
  /**
   * When true, adds a drop shadow. Useful for making the assist chip easier to see on
   * certain backgrounds (ex: on top of a photo or map)
   */
  chipElevation: PropTypes.bool,
  /**
   * Sets the assist chip as disabled.
   */
  disabled: PropTypes.bool,
  /**
   * Adds a leading icon. Takes an `Icon` component but ignores its `size` prop
   * (i.e. the icon size is fixed). Does not support `DetailedIcon`.
   */
  icon: PropTypes.node
} : {};
FilterChip.defaultProps = {
  chipElevation: false,
  disabled: false,
  icon: null
};